module.exports = __webpack_public_path__ + "static/media/3n.e15a8c09.jpg";